import React from 'react';

import { PAYMENT_ACH, PAYMENT_FLINKS, PAYMENT_LEAN } from 'apps/auth/constants/Constants';

import DcAchAccounts from './DcAchAccounts';
import DcLeanAccountList from './DcLeanAccountList';
import Flinks from '../../Flinks/Flinks';

const DcAccountsWithPaymentMethod = ({ formName, paymentMethod, clickHandler, returnToCalculator, dcSources, modalRef, icon, badge, actionBanner }) => {
    const isFlinks = paymentMethod.method === PAYMENT_FLINKS;
    const isAch = paymentMethod.method === PAYMENT_ACH;
    const isLean = paymentMethod.method === PAYMENT_LEAN;

    if (isFlinks) {
        return (
            <Flinks
                flinks={dcSources?.FLINK}
                formName={formName}
                clickHandler={clickHandler}
                isSortedPaymentMethods={true}
                badge={badge}
                actionBanner={actionBanner}
            />
        );
    }
    if (isAch) {
        return (
            <DcAchAccounts
                achAccounts={dcSources?.ACH}
                paymentMethod={paymentMethod}
                formName={formName}
                returnToCalculator={returnToCalculator}
                clickHandler={clickHandler}
                badge={badge}
                actionBanner={actionBanner}
            />
        );
    }
    if (isLean) {
        return (
            <DcLeanAccountList
                accounts={dcSources?.LEAN}
                paymentMethod={paymentMethod}
                clickHandler={clickHandler}
                modalRef={modalRef}
                formName={formName}
                icon={icon}
                badge={badge}
                actionBanner={actionBanner}
            />
        );
    }
    return null;
};
export default DcAccountsWithPaymentMethod;
